import { StateModalComponent } from "@/interfaces/modelos";

export const ADD_MODAL = (state: StateModalComponent, id: string) => {
  state.modals.push(id);
  const modal = document.getElementById(id.toString());
  modal?.style.setProperty("z-index", "99");
};
export const REMOVE_MODAL = (state: StateModalComponent, id: string) => {
  state.modals = state.modals.filter((modalId) => modalId !== id);
  if (state.modals.length > 0) {
    select(state.modals[state.modals.length - 1], state);
  } else {
    state.selectedModal = null;
  }
};
export const SELECT_MODAL = (state: StateModalComponent, id: string) => {
  select(id, state);
};

const select = (id: string, state: StateModalComponent) => {
  state.selectedModal = id;
  // modales no seleccionados
  state.modals.filter((modalId: string) => {
    if (modalId !== id) {
      const modal = document.getElementById(modalId.toString());
      modal?.style.setProperty("z-index", "1");
    }
  });

  const modal = document.getElementById(id.toString());
  modal?.style.setProperty("z-index", "9");
  // modal?.focus();
};
